import { Fragment } from "react";
import StandingList from "~pages/Standings/components/StandingList";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";
import type { TransformedResult } from "~pages/Standings/types/transformedResult";
import { sortNestedTables } from "~pages/Standings/utilities/sortNestedTables";

type Props = {
  divisions: TransformedResult<StandingTransformed>[];
  selectedColumns: string[];
};

const StandingsDivision = ({ divisions, selectedColumns }: Props) => {
  const sortedDivisions = divisions?.sort((divisionA, divisionB) => sortNestedTables(divisionA, divisionB));

  return (
    <span style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {sortedDivisions?.map((division) => (
        <Fragment key={division.entity?.id}>
          <StandingList title={division.entity?.name} selectedColumns={selectedColumns} data={division.values} />
        </Fragment>
      ))}
    </span>
  );
};

export default StandingsDivision;
